var map = {
	"./0.jpg": 573,
	"./1073.jpg": 780,
	"./1163.jpg": 781,
	"./1216.jpg": 782,
	"./1267.jpg": 783,
	"./216.jpg": 784,
	"./2839.jpg": 785,
	"./2840.jpg": 786,
	"./2971.jpg": 787,
	"./4279.jpg": 788,
	"./4309.jpg": 789,
	"./4379.jpg": 790,
	"./4386.jpg": 791,
	"./4399.jpg": 792,
	"./44.jpg": 793,
	"./45.jpg": 794,
	"./4590.jpg": 795,
	"./4594.jpg": 796,
	"./46.jpg": 797,
	"./4633.jpg": 798,
	"./4678.jpg": 799,
	"./49.jpg": 800,
	"./5835.jpg": 801,
	"./6106.jpg": 802,
	"./6139.jpg": 803,
	"./6194.jpg": 804,
	"./6195.jpg": 805,
	"./66.jpg": 574,
	"./76.jpg": 806,
	"./80.jpg": 807,
	"./81.jpg": 575,
	"./avetar.jpg": 90
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 106;